import { mapState, mapActions } from 'vuex';
import {
  Component, Vue, Watch, Mixins, Prop, Ref,
} from 'vue-property-decorator';

@Component({
  name: 'LoginForm',
})
export default class LoginForm extends Vue {
  @Ref('emailfield') readonly emailfield!: HTMLInputElement

  sending = false;

  step = 1;

  dialog = false;

  email = '';

  emailRules = [
    (v: string) => !!v || 'E-mail is required',
    (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
  ]

  valid = false;

  errors: Error[] = [];

  secret = '';

  submit() {
    this.sending = true;
    if (!this.valid) {
      return;
    }
    this.$auth.signIn({ email: this.email }).then((secret) => {
      this.step = 2;
      this.secret = secret;
    }).catch((error) => {
      this.$alert(error);
      this.errors.push(error);
    }).finally(() => {
      this.sending = false;
    });
  }

  @Watch('dialog')
  onDialogChange(to: boolean) {
    if (to === false) {
      this.step = 1;
    } else {
      requestAnimationFrame(() => {
        this.emailfield.focus();
      });
    }
  }

  @Watch('loginForm')
  onLoginFormChange(to: boolean) {
    this.dialog = to;
  }

  @Watch('step')
  onStepChange(to: number) {
    if (to === 2) {
    }
  }
}
